import { Component, Input, TemplateRef } from '@angular/core';
import { DataManager, Query, ODataV4Adaptor, Predicate } from '@syncfusion/ej2-data';
import { environment } from 'src/environments/environment';
import { SaveEventArgs, EditSettingsModel, Logger, PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-mte-index',
  templateUrl: './mte-index.component.html',
  styleUrls: ['./mte-index.component.scss']
})
export class MteIndexComponent {
  @Input() obj: String;
  @Input() title: String;
  @Input() query: Query =  new Query();
  @Input() editSettings: EditSettingsModel = { allowAdding: true, mode: 'Dialog', allowEditing: true };
  @Input() toolbar: string[] = ['Add', 'Edit', 'Delete']
  @Input() columns: object[];
  @Input() editTemplate: TemplateRef<any>;
  @Input() actionBegin: (args: SaveEventArgs) => void; // Input for actionBegin function
  @Input() actionComplete: (args: any) => void; // Input for actionComplete function

  baseUrl: string = environment.baseUrl.replace('/api/', '/odata/');  
  data: DataManager;
  

  public pageOptions: PageSettingsModel =  { pageSize: 25, pageSizes: [25, 50, 100], pageCount: 5 };
  public submitClicked: boolean = false;
  currentUser:any;

  constructor(private authenticationService: AuthenticationService, private formBuilder: UntypedFormBuilder) { }
  ngOnInit(): void {
    this.currentUser = this.authenticationService.currentUserValue;

    this.data = new DataManager({
      url: this.baseUrl + this.obj,
      adaptor: new ODataV4Adaptor(),
      headers: [{ 'Authorization': 'Bearer ' + this.currentUser.token }]
    });
  }  
}